import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import remarkGfm from "remark-gfm";
import { ClientServiceV2 } from "../component/services/client.service.v2";
import Markdown from "react-markdown";

const PublicDocViewer = () => {
    const { docName } = useParams();
    const [content, setContent] = useState("");
    const [loading, setLoading] = useState(true);

    const getPublicDoc = async () => {
        setLoading(true);
        await ClientServiceV2.getPublicDoc(docName).then((res) => {
            if (res.status === 200) {
                const text = res.data?.data?.content;

                if (!text || text.trim().length === 0) {
                    setContent("## No document found");
                } else {
                    setContent(text);
                }
            }
        }).catch((err) => {
            const status = err?.response?.status;
            const message = err?.response?.data?.message;
            if (status === 404 && message) {
                setContent(`## ${message}`);
            } else {
                setContent("## No document found");
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        getPublicDoc();
    }, [docName]);

    if (loading) {
        return (
            <div style={{ padding: "2rem", textAlign: "center" }}>
                <h3>Loading document...</h3>
            </div>
        );
    }

    return (
        <div
            style={{
                minHeight: "100vh",
                backgroundColor: "#fafbff",
                padding: "2rem",
            }}
        >
            <div
                style={{
                    maxWidth: "860px",
                    margin: "0 auto",
                    backgroundColor: "#ffffff",
                    border: "1px solid #e0f2fe",
                    borderRadius: "12px",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
                    padding: "2.5rem 3rem",
                    color: "#374151",
                    lineHeight: 1.75,
                    fontFamily: "inherit",
                }}
            >
                <Markdown
                    remarkPlugins={[remarkGfm]}
                >
                    {content}
                </Markdown>
            </div>
        </div>
    );
};

export default PublicDocViewer;
